/**
 * Reject Category 코드 목록.
 *
 * 템플릿 상세의 Reject Categories 태그와 Templates 리스트 필터가 함께 쓴다.
 * value 는 API 가 주고받는 원본 코드이고, 화면에는 rejectCategoryLabel() 로
 * "rejectReason" 접두어를 뗀 라벨을 노출한다.
 */
export const rejectCategoryCodes = [
  "rejectReasonSelfHarm",
  "rejectReasonSexualOrViolent",
  "rejectReasonHarassment",
  "rejectReasonIllegal",
  "rejectReasonCopyright",
  "rejectReasonMisinformation",
  "rejectReasonPolitical",
  "rejectReasonDuplicate",
  "rejectReasonOther",
];

/** 필터에서 "조건 없음"을 뜻하는 값. API 로는 전달하지 않는다. */
export const defaultAllRejectCategory = "all";

/**
 * reject category 코드에서 "rejectReason" 접두어를 떼어 표시용 라벨로 만든다.
 * (예: "rejectReasonSelfHarm" -> "SelfHarm")
 *
 * 접두어가 없는 값이 들어오면 원본을 그대로 쓴다. 서버에서 형식이 바뀌어도
 * 값이 빈 문자열로 사라지지 않게 하기 위함이다.
 */
export const rejectCategoryLabel = (category: string) => {
  const label = category.replace(/^rejectReason/, "");
  return label === "" ? category : label;
};

/** Select 컴포넌트에 넘길 옵션 목록. (맨 앞에 All) */
export const rejectCategoryList = [
  { label: "All", value: defaultAllRejectCategory },
  ...rejectCategoryCodes.map((code) => ({
    label: rejectCategoryLabel(code),
    value: code,
  })),
];
